import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-service-agreement',
    templateUrl: './service-agreement.component.html',
    styleUrls: ['./service-agreement.component.scss'],
    standalone: false
})
export class ServiceAgreementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
